import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CircleIcon } from 'images';
import SettingActions from 'reducers/Setting';

class MenuButton extends React.Component {
	static propTypes = {
		dispatch: PropTypes.func
	}

	handleMenuOpen = () => {
		const { dispatch } = this.props;
		dispatch(SettingActions.toggleSidebar());
	}

	render() {
		return (
			<button
				type="button"
				className="w-8 h-8 mr-8 focus:outline-none flex flex-col justify-between items-center"
				onClick={this.handleMenuOpen}>
				<CircleIcon className="overflow-visible" />
				<CircleIcon className="overflow-visible" />
				<CircleIcon className="overflow-visible" />
			</button>
		);
	}
}

export default connect()(MenuButton);
